// frontend/src/components/automationsGrantSummary.js
// Plain-language grant summary for the Automations UI (spec §6). FLOOR_TYPES
// mirrors the backend NEVER_PREAUTHORIZABLE set — these are DISABLED in the
// grant editor (never selectable).
export const FLOOR_TYPES = new Set([
  'data_delete', 'payment_send', 'financial_transaction', 'create_account', 'publish_listing',
]);

// Mirrors backend AUTOMATION_ACTION_TYPES (grant.js) — the positive
// automation-eligibility allow-list. Cross-package parity is proved from the
// backend side (grant.test.js imports this file directly — see the comment
// there); keep this file at zero imports so that import keeps working.
export const ALLOWED_ACTION_TYPES = new Set([
  'send_email', 'create_draft', 'calendar_create_event',
]);

export function grantSummary(grant) {
  if (!grant) return 'Propose-only — every action waits for your approval.';
  const parts = [];
  const types = (grant.action_types || []).join(', ');
  if (grant.max_per_day != null) parts.push(`may ${types} ≤${grant.max_per_day}/day`);
  else parts.push(`may ${types}`);
  if (grant.max_per_run != null) parts.push(`≤${grant.max_per_run}/run`);
  if (grant.window?.start && grant.window?.end) parts.push(`${grant.window.start}–${grant.window.end}`);
  parts.push('TCPA-checked');
  if (grant.dry_run_until_runs) parts.push(`dry-run for ${grant.dry_run_until_runs} more run(s)`);
  if (grant.expires_at) parts.push(`expires ${new Date(grant.expires_at).toLocaleDateString()}`);
  return parts.join(', ') + '.';
}
